module.exports = __webpack_public_path__ + "img/1557614067987849219.36d0544d.png";